import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPictureInPicture: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"picture-in-picture"} maskId="square-filled-radius-0-stroke-1-IconPictureInPicture"><path d="M2 4V18H10V17H3V5H19V12H20V4H2Z" fill="currentColor"/><path d="M12 14V21H22V14H12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPictureInPicture;
